import Button from "@mui/joy/Button";
import DialogTitle from "@mui/joy/DialogTitle";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import Stack from "@mui/joy/Stack";
import Textarea from "@mui/joy/Textarea";
import * as React from "react";
import { date } from "../../../shared/utils/time";

interface NewCohortModalProps {
  readonly open: boolean;
  readonly setOpen: (open: boolean) => void;
  readonly handleCreateCohort: (title: string, description: string) => Promise<void>;
}

export default function NewCohortModal({ open, setOpen, handleCreateCohort }: NewCohortModalProps) {
  const [title, setTitle] = React.useState<string>("Cohort of " + date());
  const [description, setDescription] = React.useState<string>("");
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <ModalDialog sx={{ width: "500px" }}>
        <form
          onSubmit={async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            setIsSubmitting(true);
            try {
              await handleCreateCohort(title, description);
              setOpen(false);
            } finally {
              setIsSubmitting(false);
            }
          }}
        >
          <DialogTitle>Build a new cohort</DialogTitle>
          <Stack spacing={2} sx={{ mt: 2 }}>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input
                value={title}
                onChange={(event) => setTitle(event.target.value)}
                autoFocus
                required
                disabled={isSubmitting}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Description</FormLabel>
              <Textarea
                value={description ?? ""}
                onChange={(event) => setDescription(event.target.value)}
                minRows={3}
                disabled={isSubmitting}
              />
            </FormControl>
            <Button type="submit" loading={isSubmitting} disabled={isSubmitting}>
              Create
            </Button>
          </Stack>
        </form>
      </ModalDialog>
    </Modal>
  );
}
